import { useTranslation } from "react-i18next";
import { inferHealthDimensionStatus } from "../constants/scforhClubHealth";
import "./ScforhDimensionStatus.css";

/**
 * Snapshot of which health dimensions look already applied vs thinner,
 * so admins pick what to grow for members / club SMART.
 */
export default function ScforhDimensionStatus({
  seed,
  groupNames,
  status: statusProp,
  tone = "light",
  lng,
} = {}) {
  const { t, i18n } = useTranslation();
  const translate = lng ? i18n.getFixedT(lng) : t;
  const status =
    statusProp || inferHealthDimensionStatus(seed, { groupNames });
  if (!status) return null;

  return (
    <section className={`scforh-dim-status scforh-dim-status--${tone}`}>
      <p className="scforh-dim-status__eyebrow">
        {translate("scforhDimStatusEyebrow")}
      </p>
      <p className="scforh-dim-status__snapshot">
        {translate(`scforhDimStatus_${status.snapshotKey}`)}
      </p>
      <div className="scforh-dim-status__cols">
        {status.likelyApplied.length ? (
          <div className="scforh-dim-status__col">
            <p className="scforh-dim-status__label">
              {translate("scforhDimApplied")}
            </p>
            <ul>
              {status.likelyApplied.map((id) => (
                <li key={id} className={`scforh-dim-chip scforh-dim-chip--${id}`}>
                  {translate(`scforhHealthDimensions_${id}`)}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        {status.underApplied.length ? (
          <div className="scforh-dim-status__col">
            <p className="scforh-dim-status__label scforh-dim-status__label--grow">
              {translate("scforhDimGrow")}
            </p>
            <ul>
              {status.underApplied.map((id) => (
                <li key={id} className={`scforh-dim-chip scforh-dim-chip--${id} scforh-dim-chip--grow`}>
                  {translate(`scforhHealthDimensions_${id}`)}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
      <p className="scforh-dim-status__hint">{translate("scforhDimGrowHint")}</p>
    </section>
  );
}
